import { useEffect, useRef } from "react";
import { useAccount, useSwitchChain } from "wagmi";
import { polygon } from "wagmi/chains";

const TARGET_CHAIN_ID = polygon.id;

export function ChainEnforcer() {
  const { isConnected, chainId } = useAccount();
  const { switchChainAsync } = useSwitchChain();
  const inFlightRef = useRef(false);
  const lastAttemptRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isConnected || !chainId) return;
    if (chainId === TARGET_CHAIN_ID) {
      lastAttemptRef.current = null;
      return;
    }
    if (inFlightRef.current) return;
    if (lastAttemptRef.current === chainId) return;

    inFlightRef.current = true;
    lastAttemptRef.current = chainId;

    switchChainAsync({ chainId: TARGET_CHAIN_ID })
      .catch((err) => {
        console.warn("[chain-enforcer] Failed to switch to Polygon:", err?.message || err);
      })
      .finally(() => {
        inFlightRef.current = false;
      });
  }, [isConnected, chainId, switchChainAsync]);

  return null;
}
